import { render, staticRenderFns } from "./applicationUsersForbidden.vue?vue&type=template&id=a4bad402&scoped=true"
import script from "./applicationUsersForbidden.vue?vue&type=script&lang=js"
export * from "./applicationUsersForbidden.vue?vue&type=script&lang=js"
import style0 from "./applicationUsersForbidden.vue?vue&type=style&index=0&id=a4bad402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bad402",
  null
  
)

export default component.exports